
(function () {

  function escapeHTML(text) {

    const div = document.createElement('div');

    div.textContent = text;

    return div.innerHTML;

  }


  /*
  =====================================
  自动加粗重要参数
  =====================================
  */

  function highlightParameters(text) {

    let html = escapeHTML(text);


    /*
    ASTM / Titanium / PVD 等材质参数
    */
    const patterns = [

      /ASTM\s*F136/gi,

      /Grade\s*23(?:\s*Titanium)?/gi,

      /G23\s*Titanium/gi,

      /18K\s*Gold\s*PVD/gi,

      /18K\s*Gold/gi,

      /Titanium/gi,

      /Princess[-\s]?Cut\s*CZ/gi,

      /CZ\s*Stones?/gi,

      /Clicker(?:\s*Closure)?/gi,


      /*
      尺寸
      */
      /\b\d+(?:\.\d+)?\s*mm\b/gi,

      /\b\d+(?:\.\d+)?\s*G\b/gi,

      /\b\d+(?:\.\d+)?\s*mm\s*(?:and|&|\/)\s*\d+(?:\.\d+)?\s*mm\b/gi

    ];


    patterns.forEach(function (pattern) {

      html = html.replace(
        pattern,
        function (match) {

          /*
          防止已经被 strong 包裹时重复处理
          */

          return '<strong>' + match + '</strong>';

        }
      );

    });


    return html;

  }


  /*
  =====================================
  把多行元字段整理成：
  标题 + 描述
  =====================================
  */

  function buildProductFeatures(accordion) {

    const source =
      accordion.querySelector(
        '.senlansp-feature-source'
      );


    const target =
      accordion.querySelector(
        '.senlansp-smooth-inner'
      );


    if (!source || !target) {
      return;
    }


    const raw =
      source.textContent
        .replace(/\r/g, '')
        .trim();


    if (!raw) {
      return;
    }


    /*
    按空行拆分每一个卖点
    */
    let blocks =
      raw.split(/\n\s*\n+/)
        .map(function (block) {

          return block.trim();

        })
        .filter(Boolean);


    /*
    如果后台没有用空行隔开，
    再根据 • 开头拆分
    */
    if (blocks.length <= 1) {

      blocks =
        raw
          .split(/(?=^\s*[•·\-]\s+)/gm)
          .map(function (block) {

            return block.trim();

          })
          .filter(Boolean);

    }


    let output = '';


    blocks.forEach(function (block) {

      const lines =
        block.split('\n')
          .map(function (line) {

            return line.trim();

          })
          .filter(Boolean);


      if (!lines.length) {
        return;
      }


      /*
      第一行 = 卖点标题
      */
      let title =
        lines.shift()
          .replace(/^[•·\-]\s*/, '')
          .trim();


      /*
      剩余内容 = 正文
      */
      const description =
        lines.join(' ').trim();


      output +=
        '<div class="senlansp-feature-item">' +

          '<div class="senlansp-feature-title">' +
            escapeHTML(title) +
          '</div>';


      if (description) {

        output +=
          '<p class="senlansp-feature-description">' +
            highlightParameters(description) +
          '</p>';

      }


      output += '</div>';

    });


    target.innerHTML = output;

  }


  /*
  =====================================
  丝滑展开
  =====================================
  */

  function initSmoothAccordion() {

    document
      .querySelectorAll(
        '.senlansp-smooth-accordion'
      )
      .forEach(function (accordion) {


        /*
        先整理卖点内容
        */
        if (
          accordion.dataset.featuresBuilt !== 'true'
        ) {

          buildProductFeatures(
            accordion
          );

          accordion.dataset.featuresBuilt =
            'true';

        }


        /*
        防止重复绑定点击事件
        */
        if (
          accordion.dataset.initialized === 'true'
        ) {
          return;
        }


        accordion.dataset.initialized =
          'true';


        const trigger =
          accordion.querySelector(
            '.senlansp-smooth-trigger'
          );


        const panel =
          accordion.querySelector(
            '.senlansp-smooth-panel'
          );


        if (!trigger || !panel) {
          return;
        }


        trigger.addEventListener(
          'click',
          function () {

            const isOpen =
              accordion.classList.contains(
                'is-open'
              );


            /* 收起 */
            if (isOpen) {

              panel.style.maxHeight =
                panel.scrollHeight + 'px';


              requestAnimationFrame(
                function () {

                  panel.style.maxHeight =
                    '0px';


                  accordion.classList.remove(
                    'is-open'
                  );


                  trigger.setAttribute(
                    'aria-expanded',
                    'false'
                  );

                }
              );

            }


            /* 展开 */
            else {

              accordion.classList.add(
                'is-open'
              );


              trigger.setAttribute(
                'aria-expanded',
                'true'
              );


              panel.style.maxHeight =
                panel.scrollHeight + 'px';


              setTimeout(
                function () {

                  if (
                    accordion.classList.contains(
                      'is-open'
                    )
                  ) {

                    panel.style.maxHeight =
                      'none';

                  }

                },
                620
              );

            }

          }
        );

      });

  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmoothAccordion);
  } else {
    initSmoothAccordion();
  }

  document.addEventListener('shopify:section:load', initSmoothAccordion);

})();
